




















































































































































import { State, Getter, Action, namespace } from 'vuex-class'
import { Vue, Prop, Component, Watch } from 'vue-property-decorator'
import _ from 'lodash'
import HttpRequestServiceWithToken from '@/services/HttpRequestServiceWithToken'
import { IUser } from '@/store/modules/views/user/states'
import VueExtendedBaseComponent from '@/VueExtendedBaseComponent.vue'
import { getNationality } from '@/services/Nationality'
import { getEthnicity } from '@/services/Ethnicity'
import { getReligion } from '@/services/Religion'
import { getStatusUser } from '@/services/StatusUser'
import { getLanguage } from '@/services/Language'
import { ELevel, Menu } from '@/services/Menus'

@Component
export default class EditCaregiverDialog extends VueExtendedBaseComponent {

  private nationalityList = getNationality().nationality
  private ethnicityList = getEthnicity().ethnicity
  private religionList = getReligion().religion
  private statusUserList = getStatusUser().statusUser
  private languageList = getLanguage().language

  get openDialog() {
    return this.open
  }

  set openDialog(value: boolean) {
    this.$emit('update:open', false)
  }

  get editUserDialogOption() {
    return {
      justify: 'start',
      button: {
        justify: 'center',
        cancelButton: {
          title: 'ปิด',
          action: this.closeDialog,
          height: '30',
        },
        submitButton: {
          title: 'บันทึก',
          action: this.editUserAction,
          loading: this.loading,
          height: '30',
        },
      },
    }
  }

  get centerList() {
    return this.centerLists
  }

  get formInstant(): Vue & {
    validate: () => any
    resetValidation: () => any
    reset: () => any,
  } {
    return this.$refs.form as Vue & {
      validate: () => any
      resetValidation: () => any
      reset: () => any,
    }
  }

  @Prop() private open!: boolean
  @Prop() private callback!: () => Promise<void>
  @Prop() private user!: IUser & {
    centerId: string,
    metadate: string[],
  }

  private loading = false
  private date = null
  private menu = false
  private options = {
    page: 1,
    sortBy: ['createdAt'],
    sortDesc: [true],
    itemsPerPage: 1000,
    search: '',
  }

  private optionUser = {
    page: 1,
    sortBy: ['createdAt'],
    sortDesc: [true],
    itemsPerPage: 1000,
    search: '',
  }
  private valid = false
  private useritems = ''
  private caregiverId = ''
  private address = ''
  private graduate = ''
  private activePicker = null
  private map = {
    lat: 0,
    lon: 0,
  }
  private nationality = ''
  private ethnicity = ''
  private religion = ''
  private language = []
  private experience = ''
  private charisma = ''
  private centerId = ''
  // private urlCenter = ''
  private urlUser = ''
  private name = ''
  private status = ''
  private profileImg = ''
  private caregiverLevel = '10'
  private caregiverLevelLists = [
    { text: 'ขั้นพื้นฐาน', value: '10' },
    { text: 'ขั้นสูง', value: '20' },
  ]

  @Action('center/getCenterList')
  private getCenterList!: (headerParams: {
    headers: {
      page: number,
      limit: number,
      sortBy: string,
      sortDesc: boolean,
      search: string,
      filter: string,
    },
  }) => void

  @Getter('map/getMapUserLocation')
  private userMapData!: { lat: number; lon: number, address: string }

  @Getter('center/itemLists')
  private centerLists!: () => void

  private phoneRules = [
    (phone: string) => !!phone || 'กรุณากรอกหมายเลขโทรศัพท์มือถือ',
    (phone: string) => (phone.match(/(0|66|\+66)[1-9]{1}[0-9]{7,8}/g)!.join('') === phone) || 'รูปแบบหมายเลขโทรศัพทมือถือไม่ถูกต้อง',
  ]

  private onInputImage(file) {
    this.profileImg = file.file
  }

  private async created() {
    if (!this.user.metadata) {
      this.user.metadata = {}
    }
    this.profileImg = this.user.metadata.profile || ''
    this.centerId = this.user.centerId
    this.status = this.user.metadata.status || ''
    this.caregiverLevel = _.toString(this.user.metadata.caregiverLevel) || '10'
    this.caregiverId = this.user.metadata.caregiverId || ''
    this.nationality = this.user.metadata.nationality || ''
    this.ethnicity = this.user.metadata.ethnicity || ''
    this.religion = this.user.metadata.religion || ''
    this.language = this.user.metadata.language || []
    this.experience = this.user.metadata.experience || ''
    this.charisma = this.user.metadata.charisma || ''
    this.graduate = this.user.metadata.graduate || ''
    this.name = this.user.prefix + this.user.firstname + ' ' + this.user.lastname || ''
    this.urlUser = `${process.env.VUE_APP_API_URL}/v1/all/caregiver/${this.user._id}`
    // this.urlCenter = `${process.env.VUE_APP_API_URL}/v1/all/center/${this.user.centerId}`
    await Promise.all([
      // this.getUserCenter(),
      this.getCenterListFunc(),
    ])
  }

  private requireSelect(value) { return [(v) => !!v || 'จำเป็นต้องเลือก'] }

  private requireInput(value) { return value !== '' || 'จำเป็นต้องกรอก' }

  // private async getUserCenter() {
  //   return await HttpRequestServiceWithToken
  //     .get(this.urlCenter, {}, ( response: { name: string, _id: string }) => {
  //       // this.centerId = response._id
  //       return response
  //     })
  // }

  private async getCenterListFunc() {
    await this.getCenterList({
      headers: {
        page: this.options.page,
        limit: this.options.itemsPerPage,
        sortBy: _.get(this.options, 'sortBy[0]', 'createdAt'),
        sortDesc: _.get(this.options, 'sortDesc[0]', true),
        search: Buffer.from(this.options.search).toString('base64'),
        filter: Buffer.from(JSON.stringify({})).toString('base64'),
      },
    })
  }

  private async editUserAction() {
    const validate = this.formInstant.validate()
    if (this.requireInput(this.profileImg) !== true) {
      this.updateSnackbar({txt: 'กรุณาอัพโหลดรูปภาพ.', type: 'error'})
      return false
    }
    if (validate) {
      this.loading = true
      const careGiverData = {
        edit: {
          roleId: '8de180b16237428082fcca28913aefcd',
          centerId: this.centerId,
          metadata: {
            profile: this.profileImg,
            // caregiverId: this.caregiverId,
            graduate: this.graduate,
            nationality: this.nationality,
            ethnicity: this.ethnicity,
            religion: this.religion,
            language: this.language,
            experience: this.experience,
            charisma: this.charisma,
            status: this.status,
            caregiverLevel: parseInt(this.caregiverLevel, 10),
          },
        },
      }
      try {
        await Promise.all([
          HttpRequestServiceWithToken.putByLevel(
            `${process.env.VUE_APP_API_URL}/v1`,
            `user/${this.user._id}`,
            careGiverData.edit,
          ),
        ])
        this.updateSnackbar({txt: 'แก้ไขนักบริบาลสำเร็จ.', type: 'success'})
        await this.callback()
        this.loading = false
        this.closeDialog()
      } catch (e) {
        await this.callback()
        this.loading = false
      }
    } else {
      return false
    }
  }

  private closeDialog() {
    this.$emit('update:open', false)
  }

  @Watch('useritems', { deep: true })
  private onUpdateUserItem() {
    if (this.useritems && this.useritems[`metadata`]) {
      this.caregiverLevel = _.toString(this.useritems[`metadata`].caregiverLevel)
    }
  }
}
